module.exports = __webpack_public_path__ + "1503ec6d74cb586846c3456fc4f39e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Faceted Trapezoid.png
// module id = 776
// module chunks = 0